/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { tracked } from "@glimmer/tracking";
import Component, { Textarea } from "@ember/component";
import { concat } from "@ember/helper";
import { action, computed } from "@ember/object";
import DButton from "discourse/components/d-button";
import DModal from "discourse/components/d-modal";
import DModalCancel from "discourse/components/d-modal-cancel";
import routeAction from "discourse/helpers/route-action";
import { i18n } from "discourse-i18n";

export default class CirclesMembershipReasonModal extends Component {
  @tracked submitting;

  get rawTitle() {
    return i18n(`discourse_circles.circle.membership_${this.mode}.title`, {
      circle_name: this.model.circle.name,
    });
  }

  @computed("mode")
  get labelText() {
    return i18n(`discourse_circles.circle.membership_${this.mode}.reason`);
  }

  @computed("mode")
  get disclaimerText() {
    return i18n(
      `discourse_circles.circle.membership_${this.mode}.reason_disclaimer`,
      {
        username: this.model.username,
        defaultValue: "",
      }
    );
  }

  @computed("submitting")
  get disableSubmit() {
    return this.submitting;
  }

  get reason() {
    return this.model.reason;
  }

  set reason(value) {
    this.model.reason = value;
  }

  get mode() {
    return this.model.mode || "request";
  }

  @action
  submit() {
    this.submitting = true;

    try {
      this.model.onSubmit(this.reason);
      this.closeModal();
    } finally {
      this.submitting = false;
    }
  }

  <template>
    <DModal
      @closeModal={{@closeModal}}
      @title={{this.rawTitle}}
      @tagName="form"
      class="request-circles-membership-form circles-membership-reason-modal"
    >
      <:body>
        <div class="control-group">
          <label>
            {{this.labelText}}
          </label>

          <Textarea
            disabled={{this.saving}}
            @value={{this.reason}}
            rows={{4}}
          />

          <div class="disclaimer">
            {{this.disclaimerText}}
          </div>
        </div>
      </:body>

      <:footer>
        <DButton
          @action={{this.submit}}
          @disabled={{this.disableSubmit}}
          @label={{concat
            "discourse_circles.circle.membership_"
            this.mode
            ".submit"
          }}
          class="btn-primary"
        />

        <DModalCancel @close={{routeAction "closeModal"}} />
      </:footer>
    </DModal>
  </template>
}
